import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import FlexBox from '../../../../../components/FlexBox';
import messages from '../../messages';
import OptionsContainer from '../../../components/OptionsContainer';
import Textbox from '../../../components/Textbox';
import PageSectionHeader from '../../../components/PageSectionHeader';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';
import FlightDatePicker from '../../../components/FlightDatePicker/index';
import AsyncButton from '../../../../../components/AsyncButton/index';
import DatePicker from '../../../components/DatePicker/index';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
import TextArea from '../../../components/TextArea';

export class FlightDetailsForBaggageDelay extends React.Component {
  onChange = () => {
    this.props.getFlightStatus();
  };

  render() {
    const { isReadOnly } = this.props;
    const {
      typeOfTransportForBaggageDelay,
      flightNumberForBaggageDelay,
      flightDateForBaggageDelay,
      flightDetailsForBaggageDelay = {},
      cruiseLineDetailsForBaggageDelay = {},
      otherDetailsForBaggageDelay = {},
    } = this.props.isSummary ? this.props.summaryFormValue() : this.props.form;
    const isFlightNumberValid = this.props.checkFlightNumberOnly(flightNumberForBaggageDelay);
    const isFlightDateValid = this.props.checkFlightDateOnly(flightDateForBaggageDelay);
    const flights = flightDetailsForBaggageDelay.flights || [];
    const flightDetail = flights.length === 1 ? flights[0] : flights[flightDetailsForBaggageDelay.selectedFlightIndex];
    const showSectionFlightDetails = flightDetailsForBaggageDelay && (flightDetailsForBaggageDelay.onSuccessFlighAPIRequest || flightDetailsForBaggageDelay.callFailFlighAPIRequest);
    const isDisable = isReadOnly || (flightDetailsForBaggageDelay && (flightDetailsForBaggageDelay.onSuccessFlighAPIRequest || !flightDetailsForBaggageDelay.manuallyEnterFlight));
    return (
      <div>
        <div className={'pt-2'} style={{ fontWeight: 'bold' }}>
          <FormattedMessage {...messages.typeOfTransport} />
        </div>
        <div className={'ml-2 row pt-2'}>
          <div className={'col-sm-12 form-group'}>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="airline"
                  checked={typeOfTransportForBaggageDelay === 'airline'}
                  onChange={this.props.handleChangeTypeOfTransport('form.typeOfTransportForBaggageDelay')}
                />
                <FormattedMessage {...messages.airline} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="cruiseLine"
                  checked={typeOfTransportForBaggageDelay === 'cruiseLine'}
                  onChange={this.props.handleChangeTypeOfTransport('form.typeOfTransportForBaggageDelay')}
                />
                <FormattedMessage {...messages.cruiseLine} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="other"
                  checked={typeOfTransportForBaggageDelay === 'other'}
                  onChange={this.props.handleChangeTypeOfTransport('form.typeOfTransportForBaggageDelay')}
                />
                <FormattedMessage {...messages.other} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {typeOfTransportForBaggageDelay === 'airline' &&
          <div className={'ml-2'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
            </PageSectionHeader>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="flightNumber"
                  validators={[this.props.checkFlightNumberOnly, required]}
                  group={this.props.validatorGroup}
                  addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
                  validationCounter={this.props.validationCounter}
                  validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
                  defaultValue={flightNumberForBaggageDelay}
                  fieldName={messages.flightNumber}
                >
                  <Textbox
                    name="flightNumber"
                    type="text"
                    onChange={this.props.handleChange('form.flightNumberForBaggageDelay')}
                    value={flightNumberForBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.flightNumber}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkFlightNumberOnly">
                    <FormattedMessage
                      {...messages.checkFlightNumber}
                      values={messages.flightNumber}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="flightDate"
                  validators={[this.props.checkFlightDateOnly, required]}
                  group={this.props.validatorGroup}
                  addValidatorToGroup={this.props.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.props.validatorGroup.validChangeInGroup}
                  validationCounter={this.props.validationCounter}
                  validatorLeaveGroup={this.props.validatorGroup.removeValidatorToGroup}
                  defaultValue={flightDateForBaggageDelay}
                  fieldName={messages.flightDate}
                >
                  <FlightDatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="flightDate"
                    type="text"
                    onDayChange={this.props.handleDayChange('form.flightDateForBaggageDelay')}
                    value={flightDateForBaggageDelay}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.flightDate}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkFlightDateOnly">
                    <FormattedMessage
                      {...messages.checkFlightDate}
                      values={messages.flightDate}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-2 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <AsyncButton
                  id="searchFlightButton"
                  className={'btn-authentication'}
                  disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                  loading={this.props.loading}
                  spinner={this.props.showSpinnerForElement('searchFlightButton')}
                  onClick={this.props.flightVerificationForBaggageDelay('flightDetailsForBaggageDelay')}
                >
                  Search Flight
                </AsyncButton>
              </div>
            </div>
            {flightDetailsForBaggageDelay.onPendingFlighAPIRequest && (
              <div className={'ml-2 row'}>
                <div style={{ fontWeight: 'bold' }}>
                  <FormattedMessage {...messages.pendingFlightApiRequest} />
                </div>
              </div>
            )}
            {flightDetailsForBaggageDelay.callFailFlighAPIRequest && flightDetailsForBaggageDelay && flightDetailsForBaggageDelay.error && (
              <div className={'row'}>
                <div className={'col-sm-12'} style={{ color: 'red' }}>
                  {flightDetailsForBaggageDelay.error}
                </div>
              </div>
            )}
            {flightDetailsForBaggageDelay.callFailFlighAPIRequest && flightDetail && (
              <div className={'row'}>
                <div className={'form-group col-md-6'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="signature"
                      checked={flightDetailsForBaggageDelay.manuallyEnterFlight === true}
                      onChange={this.props.handleChange('form.flightDetailsForBaggageDelay.manuallyEnterFlight')}
                    />
                    <span>
                      <FormattedMessage {...messages.manuallyEnterFlight} />
                    </span>
                  </OptionsContainer>
                </div>
                <div className={'form-group col-md-6'}>
                </div>
              </div>
            )}
            {(flightDetailsForBaggageDelay.onSuccessFlighAPIRequest && flights.length > 1) && (
              <div className="row">
                <div className="col-sm-12">
                  <PageSectionHeader>
                    <FormattedMessage {...messages.pleaseSelectYourFlightBelow} />
                  </PageSectionHeader>
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th />
                          <th><FormattedMessage {...messages.originAirport} /></th>
                          <th><FormattedMessage {...messages.destinationAirport} /></th>
                          <th><FormattedMessage {...messages.scheduledDeparture} /></th>
                        </tr>
                      </thead>
                      <tbody>
                        {flights.map((flight, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="radio"
                                name="selectedFlight"
                                value={index}
                                checked={flightDetailsForBaggageDelay.selectedFlightIndex === index}
                                onChange={() => this.props.handleFlightSelection('form.flightDetailsForBaggageDelay.selectedFlightIndex', index)}
                                disabled={isReadOnly}
                              />
                            </td>
                            <td>{flight.originAirport}</td>
                            <td>{flight.destinationAirport}</td>
                            <td>{flight.flightDate}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {(showSectionFlightDetails && flightDetail) && (
              <div className={'row'}>
                <div className={'col-sm-12'}>
                  <Section>
                    <ControlContainer>
                      <div className={'row'}>
                        <div className={'col-sm-2'}>
                        </div>
                        <div className={'col-sm-3'}>
                          <h4>
                            <FormattedMessage {...messages.flightDetails} />
                          </h4>
                        </div>
                        <div className={'col-sm-3'}>
                          <strong>
                            <FormattedMessage {...messages.searchSuccess} />:
                          </strong>{' '}
                          {flightDetailsForBaggageDelay.success ? 'Yes' : 'No'}
                        </div>
                        <div className={'col-sm-2'}>
                        </div>
                      </div>
                      <div className={'row'}>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.flightNumber} />
                          </PageSectionHeader>
                          <Textbox
                            name="flightNumber"
                            type="text"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForBaggageDelay', 'flightNumber')}
                            value={flightDetail.flightNumber}
                            disabled={isDisable}
                          />
                        </div>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.flightDate} />
                          </PageSectionHeader>
                          <DatePicker
                            name="flightDate"
                            type="text"
                            onDayChange={this.props.handleChangeFlightDetail('flightDetailsForBaggageDelay', 'flightDate')}
                            value={flightDetail.flightDate}
                            disabled={isDisable}
                          />
                        </div>
                      </div>
                      <div className={'row'}>
                        <div className={'col-sm-12 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.airline} />
                          </PageSectionHeader>
                          <Textbox
                            name="airline"
                            type="text"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForBaggageDelay', 'airline')}
                            value={flightDetail.airline}
                            disabled={isDisable}
                          />
                        </div>
                      </div>
                      <div className={'row'}>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.originAirport} />
                          </PageSectionHeader>
                          <Textbox
                            name="originAirport"
                            type="text"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForBaggageDelay', 'originAirport')}
                            value={flightDetail.originAirport}
                            disabled={isDisable}
                          />
                        </div>
                        <div className={'col-sm-6 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.destinationAirport} />
                          </PageSectionHeader>
                          <Textbox
                            name="destinationAirport"
                            type="text"
                            onChange={this.props.handleChangeFlightDetail('flightDetailsForBaggageDelay', 'destinationAirport')}
                            value={flightDetail.destinationAirport}
                            disabled={isDisable}
                          />
                        </div>
                      </div>
                    </ControlContainer>
                  </Section>
                </div>
              </div>
            )}
          </div>
        }
        {typeOfTransportForBaggageDelay === 'cruiseLine' &&
          <div className={'ml-2'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.cruiseLine} />
                </PageSectionHeader>
                <Textbox
                  name="cruiseLine"
                  type="text"
                  onChange={this.props.handleChange('form.cruiseLineDetailsForBaggageDelay.cruiseLine')}
                  value={cruiseLineDetailsForBaggageDelay.cruiseLine}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.cruiseNumber} />
                </PageSectionHeader>
                <Textbox
                  name="cruiseNumber"
                  type="text"
                  onChange={this.props.handleChange('form.cruiseLineDetailsForBaggageDelay.cruiseNumber')}
                  value={cruiseLineDetailsForBaggageDelay.cruiseNumber}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.departureDate} />
                </PageSectionHeader>
                <DatePicker
                  name="departureDate"
                  type="text"
                  onDayChange={this.props.handleDayChange('form.cruiseLineDetailsForBaggageDelay.departureDate')}
                  value={cruiseLineDetailsForBaggageDelay.departureDate}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.arrivalDate} />
                </PageSectionHeader>
                <DatePicker
                  name="arrivalDate"
                  type="text"
                  onDayChange={this.props.handleDayChange('form.cruiseLineDetailsForBaggageDelay.arrivalDate')}
                  value={cruiseLineDetailsForBaggageDelay.arrivalDate}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.departurePort} />
                </PageSectionHeader>
                <Textbox
                  name="departurePort"
                  type="text"
                  onChange={this.props.handleChange('form.cruiseLineDetailsForBaggageDelay.departurePort')}
                  value={cruiseLineDetailsForBaggageDelay.departurePort}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.arrivalPort} />
                </PageSectionHeader>
                <Textbox
                  name="arrivalPort"
                  type="text"
                  onChange={this.props.handleChange('form.cruiseLineDetailsForBaggageDelay.arrivalPort')}
                  value={cruiseLineDetailsForBaggageDelay.arrivalPort}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        }
        {typeOfTransportForBaggageDelay === 'other' &&
          <div className={'ml-2'}>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled} />
                </PageSectionHeader>
                <TextArea
                  name="pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForBaggageDelay.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled')}
                  value={otherDetailsForBaggageDelay.pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.departureDate} />
                </PageSectionHeader>
                <DatePicker
                  name="departureDate"
                  type="text"
                  onDayChange={this.props.handleDayChange('form.otherDetailsForBaggageDelay.departureDate')}
                  value={otherDetailsForBaggageDelay.departureDate}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.departureLocation} />
                </PageSectionHeader>
                <Textbox
                  name="departureLocation"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForBaggageDelay.departureLocation')}
                  value={otherDetailsForBaggageDelay.departureLocation}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.destination} />
                </PageSectionHeader>
                <Textbox
                  name="destination"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForBaggageDelay.destination')}
                  value={otherDetailsForBaggageDelay.destination}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.descriptionOfTravelType} />
                </PageSectionHeader>
                <Textbox
                  name="descriptionOfTravelType"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForBaggageDelay.descriptionOfTravelType')}
                  value={otherDetailsForBaggageDelay.descriptionOfTravelType}
                  disabled={isReadOnly}
                />
              </div>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.descriptionOfEvent} />
                </PageSectionHeader>
                <Textbox
                  name="descriptionOfEvent"
                  type="text"
                  onChange={this.props.handleChange('form.otherDetailsForBaggageDelay.descriptionOfEvent')}
                  value={otherDetailsForBaggageDelay.descriptionOfEvent}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

FlightDetailsForBaggageDelay.propTypes = {
  form: PropTypes.object,
  getFlightStatus: PropTypes.func,
  isReadOnly: PropTypes.bool,
  summaryFormValue: PropTypes.func,
  isSummary: PropTypes.bool,
  handleChangeTypeOfTransport: PropTypes.func,
  checkFlightNumberOnly: PropTypes.func,
  checkFlightDateOnly: PropTypes.func,
  loading: PropTypes.bool,
  handleChange: PropTypes.func,
  handleDayChange: PropTypes.func,
  handleChangeFlightDetail: PropTypes.func,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  flightVerificationForBaggageDelay: PropTypes.func,
  showSpinnerForElement: PropTypes.func,
  handleFlightSelection: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/components/FlightDetailsForBaggageDelay/index.js